import React from 'react';
import HeroSection from '../components/HeroSection';
import BenefitsSection from '../components/BenefitsSection';
import ValidationMetrics from '../components/ValidationMetrics';
import FeatureShowcase from '../components/FeatureShowcase';
import BranchConsole from '../components/BranchConsole';
import Testimonials from '../components/Testimonials';
import SEO from '../components/SEO'; // 👈 SEO Component Import

const Home = () => {
    return (
        /* 
          This structural wrapper locks the width to the viewport edge, 
          shields against child grid breakout bugs, and guarantees 
          a seamless, zero-whitespace mobile experience.
        */
        <div className="w-full overflow-x-hidden bg-zinc-950">
            {/* Main Domain Dynamic SEO Meta Tags */}
            <SEO 
                title="SOKO - Modern Restaurant POS & Multi-Branch Management Software"
                description="Run your entire restaurant with SOKO: All-in-one POS, online ordering, ingredient inventory, recipe costing, kitchen display, and employee live attendance"
                keywords={[
                    "SOKO restaurant management application",
                    "real time kitchen display system with pos",
                    "restaurant inventory and recipe management software",
                    "multi branch restaurant management",
                    "restaurant inventory tracking",
                    "custom restaurant online ordering system",
                    "commission free online ordering"
                ]}
                image="https://getsoko.app/favicon.png"
                url="https://getsoko.app/"
            />

            <HeroSection />
            <BenefitsSection />
            <ValidationMetrics />
            <FeatureShowcase />
            <BranchConsole />
            <Testimonials />
        </div>
    );
};

export default Home;